export const Platform = {
	WINDOWS: 'Windows',
	MAC: 'Mac',
	LINUX: 'Linux',
	ANDROID: 'Android',
	CHROME_OS: 'Chrome OS',
} as const

export const SYSTEM_FONTS = ['caption', 'icon', 'menu', 'message-box', 'small-caption', 'status-bar']
